"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumBitwiseHelper = exports.EnumStringHelper = void 0;
class EnumStringHelper {
    constructor(_obj, _valuesToStrings = null) {
        this._obj = _obj;
        this._valuesToStrings = _valuesToStrings;
        this.Keys = null;
        this.Values = null;
        this.Keys = Object.keys(this._obj)
            .filter(k => typeof this._obj[k] === 'string');
        this.Values = this.Keys.map(k => this._obj[k]);
    }
    keyToString(key) {
        return this._valuesToStrings
            ? this._valuesToStrings[this._obj[key]]
            : key;
    }
    valueToString(v) {
        const custom = this._valuesToStrings && this._valuesToStrings[v];
        return custom || v;
    }
    validateValue(v) {
        if (!v) {
            return null;
        }
        const i = this.Values.findIndex(vv => vv === v);
        return i >= 0
            ? this.Values[i]
            : null;
    }
}
exports.EnumStringHelper = EnumStringHelper;
class EnumHelper {
    constructor(_obj, _valuesToStrings = null) {
        this._obj = _obj;
        this._valuesToStrings = _valuesToStrings;
        this.Keys = null;
        this.Values = null;
        this.Keys = Object.keys(this._obj)
            .filter(k => typeof this._obj[k] === 'number');
        this.Values = this.Keys.map(k => this._obj[k]);
    }
    keyToString(key, overrideMap = null) {
        const map = overrideMap || this._valuesToStrings;
        return map
            ? map[this._obj[key]]
            : key;
    }
    keyToValue(key) {
        const v = this._obj[key];
        return v == null ? null : v;
    }
    valueToString(v, overrideMap = null) {
        const map = overrideMap || this._valuesToStrings;
        const custom = map && map[v];
        return custom || this._obj[v];
    }
    validateValue(v) {
        if (v == null || Number.isNaN(v)) {
            return null;
        }
        const i = this.Values.findIndex(vv => vv === v);
        return i >= 0
            ? this.Values[i]
            : null;
    }
}
exports.default = EnumHelper;
class EnumBitwiseHelper extends EnumHelper {
    toStrings(value, overrideMap = null) {
        if (value == 0) {
            return [this.valueToString(value, overrideMap)];
        }
        return this.Keys
            .filter(k => this._obj[k] && this.contains(value, this._obj[k]))
            .map(k => this.keyToString(k, overrideMap));
    }
    toString(value, separator = ', ', overrideMap = null) {
        const strs = this.toStrings(value, overrideMap);
        return strs.length === 0
            ? this._obj[0]
            : strs.join(separator);
    }
    contains(base, target) {
        return this.intersection(base, target) === target;
    }
    combine(...values) {
        let res = 0;
        values.forEach(v => {
            res = this.add(res, v);
        });
        return res;
    }
    add(value, other) {
        return value | other;
    }
    intersection(v1, v2) {
        return v1 & v2;
    }
    remove(value, other) {
        return value & ~other;
    }
}
exports.EnumBitwiseHelper = EnumBitwiseHelper;
//# sourceMappingURL=enum.js.map